import UrlUtils from '@spothero/utils/url';
import SearchRequestUtils from 'store/search-request/search-request-utils';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';
import SearchUtils from 'utils/search-utils';
import ExperimentUtils from 'utils/experiment';
import SearchAPI from 'api/search';

export async function createCleanedData({
    currentCity,
    cleanedParams,
    currentSearchState,
    checkoutState = {},
}) {
    const {
        page_info: {page_type: pageType, setup},
        rid,
    } = cleanedParams;
    const loadedData = await SearchRequestUtils.loadDataSequence({
        pageType,
        setup,
        isNewCity: setup.city.slug !== currentCity.data.slug,
    });

    const isScan2payFacility =
        pageType === 'checkout' && setup.facility.is_scan_to_pay;
    const isScan2payLanding = isScan2payFacility;
    const cleanedData = {
        searchRequest: SearchRequestUtils.sanitizeSearchRequestResponse({
            state: searchRequestInitialState,
            response: cleanedParams,
        }),
        checkout: {
            ...checkoutState,
            rid,
            isScan2payFacility,
            isScan2payLanding,
        },
        ...loadedData,
    };

    if (!cleanedData.city) {
        cleanedData.city = currentCity;
    }

    cleanedData.search = SearchUtils.prepareStoreData({
        initData: cleanedData,
        experimentUtils: ExperimentUtils,
        pageType,
        currentSearchState,
    });

    return cleanedData;
}

export async function fetchCleanedData({state, route}) {
    const {city, search: searchState, checkout: checkoutState} = state;
    const {
        location: {pathname, search},
    } = route;

    const {
        data: {data: cleanedParams},
    } = await SearchAPI.cleanParams({url: `${pathname}${search || ''}`});

    return createCleanedData({
        currentCity: city,
        cleanedParams,
        currentSearchState: searchState,
        checkoutState,
    });
}

export function routeToSearch({
    method,
    pageType = 'address',
    id,
    queryParams = {},
    historyState = {},
}) {
    // TODO: right now the search-params endpoint returns 'search' instead of 'address' for default page type
    // the new endpoint that replaces search-params should return a better aligned mapping to the page types we are
    // expecting in this method, 'search' should become 'address' and 'venue' should become 'destination'
    // venue determination happens on the FE only, as in, a destination that has events
    const kind =
        pageType === 'venue'
            ? 'destination'
            : pageType === 'search'
            ? 'address'
            : pageType;
    const query = UrlUtils.createQueryString({
        kind,
        // pageType 'address' does not have an associated ID
        ...(id && {id}),
        ...queryParams,
    });

    method(`/search?${query}`, historyState);
}

export function routeToSpotDetails({
    method,
    location: {pathname, search},
    spotId,
    historyState = {},
}) {
    const query = UrlUtils.createQueryString({
        ...UrlUtils.parseParams(search),
        'spot-id': spotId,
    });

    method(`${pathname}?${query}`, {...historyState, reload: false});
}
